import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { Fragment } from "react";
// import { base64logo, base64watermark } from "./BaseImages";

// import { useEffect, useState } from "react";
Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

// Definir los estilos
const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#454546",
    paddingBottom: 100, // Add padding at the bottom to make room for signatures
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },

  logo: {
    width: "auto",
    height: 64, // Reduce from 64 to 50
  },

  // Update the headerright style
  headerright: {
    width: "auto",
    height: 45, // Reduce from 25% to 10%
  },

  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "Roboto",
    color: "#000",
    marginBottom: 20,
  },
  section: {
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  textBold: {
    color: "#000",
    fontSize: 12,
    fontFamily: "Roboto",
  },
  text: {
    marginBottom: 5,
    fontSize: 12,
    fontFamily: "Roboto",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
    zIndex: -1, // Añadido para asegurar que esté detrás de otros elementos
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.04,
    zIndex: "-10",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 10,
  },

  table: {
    display: "table",
    width: "auto",
    margin: 10,
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 35,
    padding: 2,
    borderBottom: "1px solid #eee",
  },

  cell: {
    flex: 1,
    padding: "5px 5px",
    textAlign: "center",
    fontSize: "10px",
    minWidth: "20%",
    maxWidth: "25%",
    wordWrap: "break-word",
    overflow: "hidden",
  },

  striped: {
    backgroundColor: "#e0e0e0",
  },

  headerTable: {
    backgroundColor: "#f0f0f0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  horizontalLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },

  firmas: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingTop: 60,
    paddingBottom: 20,
    paddingHorizontal: 40,
  },

  columDr: {
    width: "50%",
    textAlign: "center",
  },

  signatureSection: {
    marginTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingHorizontal: 40,
  },

  signatureContainer: {
    width: "100%",
    textAlign: "center",
    alignItems: "center",
  },

  firma: {
    width: 120, // Set to exactly 45% as requested
    height: 90,
    alignSelf: "center",
  },

  signatureLine: {
    marginBottom: 5,
    fontSize: 12,
    fontFamily: "Roboto",
  },

  doctorName: {
    fontSize: 11, // Set to 11 as requested
    fontFamily: "Roboto",
    marginBottom: 2,
  },

  doctorTitle: {
    fontSize: 11, // Set to 11 as requested
    fontFamily: "Roboto",
  },

  // Footer wrapper helps position the footer at the bottom
  footerWrapper: {
    position: "absolute",
    bottom: 40,
    left: 0,
    right: 0,
  },
  textmessage: {
    flex: 1,
    textAlign: "center",
    fontSize: "10px",
    overflow: "hidden",
  },
  costRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    paddingVertical: 0, // Sin padding vertical
    height: 22, // Altura fija pequeña para cada fila
    alignItems: "center",
    backgroundColor: "#f5f5f5", // Fondo gris claro opcional
  },

  costLabel: {
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 500,
    color: "#000",
    flex: 3, // Usar flex para alineación
    paddingLeft: 5,
  },

  costValue: {
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 500,
    color: "#000",
    flex: 1,
    textAlign: "right",
    paddingRight: 5,
  },

  disclaimerRow: {
    paddingHorizontal: 40,
    paddingTop: 5,
    paddingBottom: 10,
  },

  disclaimer: {
    fontSize: 10,
    color: "#454546",
    textAlign: "right",
    fontFamily: "Roboto",
  },
});

const OdontogramaPdf = ({
  nombre,
  edad,
  fecha,
  lugarAtencion,
  seguro,
  odontogramasBackEnd,
  descuento,
  doctorData,
}) => {
  console.log("Odontogramas before: ", odontogramasBackEnd);
  // Modifiar para no filtrar piezas repetidas
  const combinedOdontogramas = [...odontogramasBackEnd];

  const odontogramas = [
    {
      piezaDental: "18",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "17",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "16",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "15 55",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "14 54",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "13 53",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "12 52",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "11 51",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "21 61",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "22 62",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "23 63",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "24 64",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "25 65",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "26",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "27",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "28",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "38",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "37",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "36",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "35 75",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "34 74",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "33 73",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "32 72",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "31 71",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "41 81",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "42 82",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "43 83",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "44 84",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "45 85",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "46",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "47",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "48",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
    {
      piezaDental: "OTROS TX",
      diagnostico: "",
      tratamiento: "",
      costo: "",
      selected: false,
    },
  ];

  const nuevoOdontogramas = odontogramas.reduce((acc, diente) => {
    const matches = combinedOdontogramas.filter((pieza) =>
      diente?.piezaDental.includes(pieza?.diente)
    );

    if (matches.length > 0) {
      matches.forEach((match) => {
        const isDuplicate = acc.some(
          (existingRow) =>
            existingRow.piezaDental === match.diente &&
            existingRow.diagnostico === match.diagnostico &&
            existingRow.tratamiento === match.tratamiento &&
            existingRow.costo === match.costo
        );

        if (!isDuplicate) {
          acc.push({
            piezaDental: match.diente,
            diagnostico: match.diagnostico,
            tratamiento: match.tratamiento,
            costo: match.costo,
            selected: match.selected,
          });
        }
      });
    } else {
      acc.push({ ...diente, selected: diente.selected });
    }
    return acc;
  }, []);

  let odontogramaCosto = 0.0;
  nuevoOdontogramas.forEach((diente) => {
    if (diente?.selected === true) {
      odontogramaCosto += parseFloat(diente?.costo);
    }
  });

  const filasSeleccionadas = nuevoOdontogramas.filter(
    (od) => od.diagnostico !== "" && od.selected
  );

  return (
    <Document>
      <Page size="LETTER" style={styles.page} wrap>
        {/* Encabezado fijo */}
        <Image fixed style={styles.watermark} src="/images/watermark.jpg" />
        <View fixed style={styles.header}>
          <Image style={styles.logo} src="/images/logoderecho.jpg" />
          <Image style={styles.headerright} src="/images/headerright.png" />
        </View>

        <Text style={styles.title}>PROFORMA</Text>

        {/* Info del paciente */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Nombre:</Text> {nombre}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Edad:</Text> {edad}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Lugar de atención:</Text>{" "}
              {lugarAtencion}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text> {fecha}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Seguro:</Text> {seguro}
            </Text>
          </View>
        </View>

        {/* Tabla de odontograma */}
        <View style={styles.table}>
          <View style={[styles.row, styles.headerTable]}>
            <Text style={styles.cell}>Pieza dental</Text>
            <Text style={styles.cell}>Diagnóstico</Text>
            <Text style={styles.cell}>Tratamiento</Text>
            <Text style={styles.cell}>Costo</Text>
          </View>
          <View style={styles.horizontalLine} />

          {filasSeleccionadas.map((odontograma, index) => (
            <Fragment key={index}>
              <View
                style={[
                  styles.row,
                  styles.headerTable,
                  index % 2 === 0 ? {} : styles.striped,
                ]}
                wrap={false}
                minPresenceAhead={30}
              >
                <Text style={styles.cell}>{odontograma.piezaDental}</Text>
                <Text style={styles.cell}>{odontograma.diagnostico}</Text>
                <Text style={styles.cell}>{odontograma.tratamiento}</Text>
                <Text style={styles.cell}>{odontograma.costo}</Text>
              </View>
              <View style={styles.horizontalLine} />
            </Fragment>
          ))}
        </View>

        {/* Costos y firma (solo al final, wrap false para que no se corte) */}
        <View wrap={false}>
          {descuento > 0 && descuento < odontogramaCosto && (
            <>
              <View style={styles.costRow}>
                <Text style={styles.costLabel}>Costo parcial</Text>
                <Text style={styles.costValue}>
                  {Math.round(odontogramaCosto)}
                </Text>
              </View>
              <View style={styles.costRow}>
                <Text style={styles.costLabel}>Descuento</Text>
                <Text style={styles.costValue}>{Math.round(descuento)}</Text>
              </View>
            </>
          )}
          <View style={styles.costRow}>
            <Text style={styles.costLabel}>Costo Total</Text>
            <Text style={styles.costValue}>
              {descuento > 0 && descuento < odontogramaCosto
                ? Math.round(odontogramaCosto - descuento)
                : Math.round(odontogramaCosto)}
            </Text>
          </View>

          <View style={[styles.row, styles.headerTable]}>
            <Text style={styles.textmessage}>
              El total del costo cotizado puede modificarse durante el proceso
              de rehabilitación del paciente
            </Text>
          </View>

          {/* Firma */}
          <View
            style={styles.signatureSection}
            wrap={false}
            minPresenceAhead={100}
          >
            <View style={styles.signatureContainer}>
              <Image style={styles.firma} src="/images/firma.png" />
              <Text style={styles.signatureLine}>______________________</Text>
              <Text style={styles.text}>{doctorData?.printer_name}</Text>
              <Text style={styles.text}>{doctorData?.specialty}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default OdontogramaPdf;
